<div class="deal-page">
  <nav class="deal-breadcrumb" [attr.aria-label]="'dealDetail.breadcrumb' | t">
    <button type="button" class="breadcrumb-back" (click)="backClicked()">
      <mat-icon>chevron_left</mat-icon>{{ 'common.back' | t }}
    </button>
    @if (product) {
      <span class="breadcrumb-sep" aria-hidden="true">·</span>
      <a routerLink="/">{{ 'dealDetail.home' | t }}</a>
      @if (product.category) {
        <span class="breadcrumb-sep" aria-hidden="true">›</span>
        <a [routerLink]="['/category', product.category]">{{ categoryKey ? (categoryKey | t) : product.category }}</a>
      }
      @if (advertiserName) {
        <span class="breadcrumb-sep" aria-hidden="true">›</span>
        <a [routerLink]="['/advertiser', advertiserName]">{{ advertiserName }}</a>
      }
    }
  </nav>

  @if (notFound) {
    <div class="deal-card deal-not-found">
      <mat-icon>search_off</mat-icon>
      <p>{{ 'dealDetail.notFound' | t }}</p>
      <a class="deal-cta" routerLink="/">{{ 'dealDetail.seeAllDeals' | t }}</a>
    </div>
  }

  @if (product) {
    <div class="deal-layout">
      <div class="deal-main">

        <section class="deal-card deal-hero" [class.deal-expired]="isExpired">
          <div class="deal-media">
            <a [attr.href]="product.inStore ? null : product.affiliateUrl" target="_blank" rel="sponsored noopener" (click)="incrementViewNumberProduct()">
              @if (product.pictureUrl) {
                <img [src]="product.pictureUrl" [appImgFallback]="product.storedPictureUrl" [alt]="product.name">
              } @else {
                <mat-icon class="deal-media-placeholder">image</mat-icon>
              }
            </a>
            @if (product.percentageDiscount) {
              <span class="deal-badge-discount" [style.background]="isExpired ? null : discountColor(product)">-{{ product.percentageDiscount }}%</span>
            }
            @if (isExpired) {
              <span class="deal-badge-expired">{{ 'deals.expired' | t }}</span>
            } @else if (daysLeft !== null) {
              <span class="deal-badge-soon">
                <mat-icon>schedule</mat-icon>
                {{ (daysLeft === 0 ? 'dealDetail.expiresToday' : 'dealDetail.expiresIn') | t: { count: daysLeft } }}
              </span>
            }
          </div>

          <div class="deal-info">
            <div class="deal-merchant-row">
              <a class="deal-merchant" [routerLink]="['/advertiser', advertiserName]">
                <span class="deal-merchant-logo">
                  @if (advertiser?.pictureUrl) {
                    <img [src]="advertiser.pictureUrl" [appImgFallback]="advertiser.storedPictureUrl" alt="">
                  } @else {
                    {{ advertiserInitials }}
                  }
                </span>
                <span class="deal-merchant-text">
                  <span class="deal-merchant-name">{{ advertiserName }}</span>
                  <span class="deal-merchant-hint">{{ 'dealDetail.seeAdvertiserDeals' | t }}</span>
                </span>
              </a>
              @if (advertiser?.isPartner) {
                <span class="deal-partner-badge">{{ 'dealDetail.partner' | t }}</span>
              }
            </div>

            <h1 class="deal-title">{{ product.name }}</h1>

            <div class="deal-vote-row">
              <div class="deal-vote">
                <button type="button" class="vote-btn" [class.vote-btn-active]="myVote === 1"
                  (click)="onVote(1)" [attr.aria-label]="'deals.voteUp' | t" [attr.aria-pressed]="myVote === 1">
                  <mat-icon>thumb_up_alt</mat-icon>
                </button>
                <span class="vote-score" [ngClass]="'vote-score-' + voteLevel">
                  <mat-icon>local_fire_department</mat-icon>{{ voteScore }}°
                </span>
                <button type="button" class="vote-btn" [class.vote-btn-active]="myVote === -1"
                  (click)="onVote(-1)" [attr.aria-label]="'deals.voteDown' | t" [attr.aria-pressed]="myVote === -1">
                  <mat-icon>thumb_down_alt</mat-icon>
                </button>
              </div>
              <span class="deal-posted">
                @if (product.submittedByPseudo) {
                  {{ 'dealDetail.postedBy' | t: { pseudo: product.submittedByPseudo } }} ·
                }
                @if (product.addedDate) {
                  {{ timeAgo(product.addedDate) }}
                }
              </span>
            </div>

            @if (product.priceDiscount || hasOldPrice) {
              <div class="deal-price-row">
                @if (product.priceDiscount) {
                  <span class="deal-price">{{ product.priceDiscount }}€</span>
                }
                @if (hasOldPrice) {
                  <span class="deal-old-price">{{ product.price | number : '1.2-2' }}€</span>
                }
                @if (product.percentageDiscount) {
                  <span class="deal-price-discount" [style.background]="isExpired ? null : discountColor(product)">-{{ product.percentageDiscount }}%</span>
                }
              </div>
            }

            <div class="deal-chips">
              @if (hasDeliveryPrice) {
                <span class="deal-chip">
                  <mat-icon>local_shipping</mat-icon>
                  @if (isFreeDelivery) {
                    {{ 'dealDetail.freeDelivery' | t }}
                  } @else {
                    {{ 'dealDetail.deliveryPrice' | t: { price: product.deliveryPrice } }}
                  }
                </span>
              }
              @if (product.area) {
                <span class="deal-chip"><mat-icon>language</mat-icon>{{ product.area }}</span>
              }
              @if (product.viewNumber) {
                <span class="deal-chip"><mat-icon>visibility</mat-icon>{{ 'dealDetail.views' | t: { count: product.viewNumber } }}</span>
              }
            </div>

            @if (product.promotionCode) {
              <div class="deal-code" [class.deal-code-expired]="isExpired">
                <div class="deal-code-value">
                  <span class="deal-code-label">{{ 'dealDetail.promoCode' | t }}</span>
                  <span class="deal-code-text">{{ product.promotionCode }}</span>
                </div>
                <button type="button" class="deal-code-btn" (click)="copyCodeAndOpenOffer()">
                  <mat-icon>{{ codeCopied ? 'check' : 'content_copy' }}</mat-icon>
                  {{ (codeCopied ? 'dealDetail.codeCopiedOfferOpened' : 'deals.copyAndUseCode') | t }}
                </button>
              </div>
            }

            @if (product.inStore) {
              <!-- Offre en magasin : pas de lien, l'enseigne et la ville à la place du bouton -->
              <div class="deal-cta deal-cta-store" [class.deal-cta-expired]="isExpired">
                <mat-icon>storefront</mat-icon>
                {{ product.storeCity
                  ? ('inStore.atCity' | t: { store: product.storeName || advertiserName, city: product.storeCity })
                  : ('inStore.at' | t: { store: product.storeName || advertiserName }) }}
              </div>
              <p class="deal-store-note">{{ 'inStore.noLink' | t }}</p>
            } @else {
            <a class="deal-cta" [class.deal-cta-expired]="isExpired" [href]="product.affiliateUrl" target="_blank" rel="sponsored noopener"
              (click)="incrementViewNumberProduct()">
              {{ advertiserName ? ('dealDetail.seeOfferAt' | t: { advertiser: advertiserName }) : ('deals.seeOffer' | t) }}
              <mat-icon>open_in_new</mat-icon>
            </a>
            }

            <div class="deal-actions">
              <button type="button" class="deal-action" [class.deal-action-active]="saved" (click)="onToggleFavorite()"
                [attr.aria-pressed]="saved" [attr.aria-label]="(saved ? 'deals.removeFavorite' : 'deals.saveFavorite') | t">
                <mat-icon>{{ saved ? 'bookmark' : 'bookmark_border' }}</mat-icon>
                {{ (saved ? 'dealDetail.saved' : 'dealDetail.save') | t }}
              </button>
              <button type="button" class="deal-action" (click)="sharePage()">
                <mat-icon>share</mat-icon>{{ 'deals.share' | t }}
              </button>
              <button type="button" class="deal-action" (click)="scrollToComments()">
                <mat-icon>forum</mat-icon>{{ product.commentCount || 0 }}
              </button>
            </div>
          </div>
        </section>

        @if (isExpired) {
          <p class="deal-expired-notice"><mat-icon>info</mat-icon>{{ 'dealDetail.expiredNotice' | t }}</p>
        }

        @if (product.description) {
          <section class="deal-card">
            <h2 class="deal-section-title">{{ 'dealDetail.about' | t }}</h2>
            <div class="deal-description" [innerHTML]="product.description"></div>
          </section>
        }

        <section class="deal-card">
          <h2 class="deal-section-title">{{ 'dealDetail.details' | t }}</h2>
          <dl class="deal-details">
            @if (advertiserName) {
              <div>
                <dt>{{ 'dealDetail.merchant' | t }}</dt>
                <dd><a [routerLink]="['/advertiser', advertiserName]">{{ advertiserName }}</a></dd>
              </div>
            }
            @if (product.category) {
              <div>
                <dt>{{ 'dealDetail.category' | t }}</dt>
                <dd>
                  <a [routerLink]="['/category', product.category]">{{ categoryKey ? (categoryKey | t) : product.category }}</a>
                  @if (product.subcategory) {
                    › {{ product.subcategory }}
                  }
                </dd>
              </div>
            }
            @if (product.brandProduct) {
              <div>
                <dt>{{ 'dealDetail.brand' | t }}</dt>
                <dd>{{ product.brandProduct }}</dd>
              </div>
            }
            @if (product.expeditionCountry) {
              <div>
                <dt>{{ 'dealDetail.shippedFrom' | t }}</dt>
                <dd>{{ product.expeditionCountry }}</dd>
              </div>
            }
            @if (product.addedDate) {
              <div>
                <dt>{{ 'dealDetail.addedOn' | t }}</dt>
                <dd>{{ formatDate(product.addedDate) }}</dd>
              </div>
            }
            @if (product.expirationDate) {
              <div>
                <dt>{{ 'dealDetail.expiresOn' | t }}</dt>
                <dd>{{ formatDate(product.expirationDate) }}</dd>
              </div>
            }
          </dl>
        </section>

        @if (advertiserDeals.length > 0) {
          <section class="deal-card deal-related">
            <h2 class="deal-section-title">{{ 'dealDetail.otherAdvertiserDeals' | t: { advertiser: advertiserName } }}</h2>
            <div class="related-grid">
              @for (deal of advertiserDeals; track deal._id) {
                <a class="related-item" [routerLink]="['/product', deal._id]">
                  <span class="related-thumb">
                    @if (deal.pictureUrl) {
                      <img [src]="deal.pictureUrl" [appImgFallback]="deal.storedPictureUrl" alt="">
                    }
                  </span>
                  <span class="related-info">
                    <span class="related-name">{{ deal.name }}</span>
                    @if (deal.priceDiscount) {
                      <span class="related-price">{{ deal.priceDiscount }}€</span>
                    } @else if (deal.promotionCode) {
                      <span class="related-code">{{ 'deals.codeLabel' | t }} {{ deal.promotionCode }}</span>
                    }
                  </span>
                </a>
              }
            </div>
            <a class="related-all" [routerLink]="['/advertiser', advertiserName]">{{ 'dealDetail.allAdvertiserDeals' | t: { advertiser: advertiserName } }} ›</a>
          </section>
        }

        @if (categoryDeals.length > 0) {
          <section class="deal-card deal-related">
            <h2 class="deal-section-title">{{ 'dealDetail.sameCategory' | t }}</h2>
            <div class="related-grid">
              @for (deal of categoryDeals; track deal._id) {
                <a class="related-item" [routerLink]="['/product', deal._id]">
                  <span class="related-thumb">
                    @if (deal.pictureUrl) {
                      <img [src]="deal.pictureUrl" [appImgFallback]="deal.storedPictureUrl" alt="">
                    }
                  </span>
                  <span class="related-info">
                    <span class="related-name">{{ deal.name }}</span>
                    <span class="related-score" [ngClass]="'vote-score-' + getVoteLevel(deal)">{{ deal.voteScore || 0 }}°</span>
                  </span>
                </a>
              }
            </div>
          </section>
        }

        <section class="deal-card comments-section" id="deal-comments">
          <h2 class="deal-section-title">{{ 'deals.comments' | t: { count: product.commentCount || 0 } }}</h2>
          <div class="comment-form">
            <textarea class="comment-input" rows="2" [placeholder]="'deals.addComment' | t" [attr.aria-label]="'deals.addComment' | t"
            [(ngModel)]="newCommentText"></textarea>
            <button type="button" class="btn-pill btn-pill-accent" [disabled]="postingComment || !newCommentText.trim()"
            (click)="postComment()">{{ 'deals.publish' | t }}</button>
          </div>
          <div class="comment-list">
            @for (comment of comments; track comment._id) {
              <div class="comment-item">
                <div class="comment-header">
                  <span class="comment-pseudo">{{comment.pseudo}}</span>
                  <span class="comment-date">{{comment.createdAt | date: 'dd/MM/yy HH:mm'}}</span>
                  @if (comment.updatedAt) {
                    <span class="comment-edited">{{ 'deals.edited' | t }}</span>
                  }
                  @if (isMyComment(comment) && editingCommentId !== comment._id) {
                    <span class="comment-actions">
                      <button type="button" class="comment-action-btn" (click)="startEditComment(comment)"
                        [attr.aria-label]="'deals.editComment' | t" [title]="'common.edit' | t">
                        <mat-icon>edit</mat-icon>
                      </button>
                      <button type="button" class="comment-action-btn comment-action-delete" (click)="deleteComment(comment)"
                        [attr.aria-label]="'deals.deleteComment' | t" [title]="'common.delete' | t">
                        <mat-icon>delete</mat-icon>
                      </button>
                    </span>
                  }
                  @if (canFollowOrIgnore(comment)) {
                    <span class="comment-actions">
                      <button type="button" class="comment-action-btn" [class.active]="isFollowedAuthor(comment)" (click)="followAuthor(comment)"
                        [attr.aria-label]="(isFollowedAuthor(comment) ? 'deals.unfollowMember' : 'deals.followMember') | t"
                        [title]="(isFollowedAuthor(comment) ? 'deals.unfollowMember' : 'deals.followMember') | t">
                        <mat-icon>{{isFollowedAuthor(comment) ? 'how_to_reg' : 'person_add'}}</mat-icon>
                      </button>
                      @if (!isIgnoredAuthor(comment)) {
                        <button type="button" class="comment-action-btn" [class.active]="friendRelation(comment) !== 'none'"
                          (click)="onFriendAction(comment)" [attr.aria-label]="friendActionLabel(comment) | t: { pseudo: comment.pseudo }"
                          [title]="friendActionLabel(comment) | t: { pseudo: comment.pseudo }">
                          <mat-icon>{{ friendActionIcon(comment) }}</mat-icon>
                        </button>
                      }
                      <button type="button" class="comment-action-btn" [class.active]="isIgnoredAuthor(comment)" (click)="ignoreAuthor(comment)"
                        [attr.aria-label]="(isIgnoredAuthor(comment) ? 'deals.unignoreMember' : 'deals.ignoreMember') | t"
                        [title]="(isIgnoredAuthor(comment) ? 'deals.unignoreMember' : 'deals.ignoreMember') | t">
                        <mat-icon>block</mat-icon>
                      </button>
                    </span>
                  }
                </div>
                @if (isIgnoredAuthor(comment)) {
                  <p class="comment-text comment-ignored">{{ 'deals.hiddenComment' | t }}</p>
                } @else if (editingCommentId === comment._id) {
                  <div class="comment-form">
                    <textarea class="comment-input" rows="2" [(ngModel)]="editCommentText" [attr.aria-label]="'deals.editComment' | t"></textarea>
                    <button type="button" class="btn-pill btn-pill-accent" [disabled]="savingComment || !editCommentText.trim()"
                    (click)="saveEditComment(comment)">{{ 'common.save' | t }}</button>
                    <button type="button" class="btn-pill btn-pill-outline" [disabled]="savingComment"
                    (click)="cancelEditComment()">{{ 'common.cancel' | t }}</button>
                  </div>
                } @else {
                  <p class="comment-text">{{comment.text}}</p>
                }
              </div>
            }
            @if (comments.length === 0) {
              <p class="no-comments">{{ 'deals.noComments' | t }}</p>
            }
          </div>
        </section>
      </div>
    </div>
  }
</div>
